<template>
  <v-app>
    <custom-notification />
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12" tile :loading="loading">
              <v-toolbar color="primary" dark class="d-flex justify-center">
                <v-toolbar-title centered class="headline font-weight-bold"
                  >Admin Login form</v-toolbar-title
                >
              </v-toolbar>
              <v-card-text>
                <custom-form action="/api/auth/login" @submitted="onSubmitted">
                  <custom-input
                    label="User name"
                    prepend-inner-icon="mdi-account-outline"
                    name="email"
                    type="email"
                  ></custom-input>

                  <custom-input
                    label="Password"
                    name="password"
                    prepend-inner-icon="mdi-lock-outline"
                    type="password"
                  ></custom-input>
                  <custom-button color="primary" block large raised tile>Login </custom-button>
                </custom-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { mapState } from 'vuex';

export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.user) {
        return next({ name: 'clients' });
      }
      return next();
    });
  },
  computed: mapState({ user: ({ auth }) => auth.user, loading: ({ apiLoading }) => apiLoading }),
  methods: {
    onSubmitted({ token, user }) {
      this.$http.setAuthenticationToken(token);
      this.$store.commit('auth/setUser', user);
      this.$router.push({ name: 'clients' });
    },
  },
};
</script>
